import axios from 'axios';
import { ACCESS_TYPE, VENDING_URL } from '../../atoms/const';
import getAllActiveRes from '../clients/getAllActive.json';
import getAllModelRes from './getAllModel.json';
import getAllRes from './getAll.json';
import addRes from './add.json';

const getAll = () => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-coffee-machines`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllRes>(url, config);
};

const getAllActive = (page?: number, size?: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}active-coffee-accounts?removed=0&page=${page ?? 0}&size=${size ?? 20}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllActiveRes>(url, config);
};

interface addCoffeeMachineProps {
    'deviceId'?: string;
    'model': string;
    'clientId': string | number;
    'location': string;
}

const add = (data : addCoffeeMachineProps) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}add-coffee-machine`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post<typeof addRes>(url, data, config);
};

const getAllModel = () => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-all-coffee-machines-models`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllModelRes>(url, config);
};

const coffeeMachine = {
  getAll,
  getAllActive,
  add,
  getAllModel,
};

export default coffeeMachine;
